import { render, staticRenderFns } from "./BreadcrumbsComponent.vue?vue&type=template&id=67802dac"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbsComponent.vue?vue&type=style&index=0&id=67802dac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports